export const convertPermissionsIntoAbilities = (permissions) => {
  if (!Array.isArray(permissions)) return []
  const abilities = [];
  permissions.forEach((permission) => {
    abilities.push(permission.nome);
  })
  return abilities;
}